module.exports = __webpack_public_path__ + "img/architetto.63e28021.png";